import { ApiHandler } from "@app/shared/services/api-handler.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";
import "rxjs/Rx";
import { API } from "environments/environment";
import { EmptyObservable } from "rxjs/observable/EmptyObservable";

@Injectable()
export class DashboardService {
  constructor(private apiHandler: ApiHandler) {}

  getDashboardData() {
    return this.apiHandler.apiGet(API.DASHBOARD_ENDPOINTS.GET_HEADER_DETAILS);
  }

  getDrivers() {
    return this.apiHandler.apiGet(API.DASHBOARD_ENDPOINTS.GET_LIVE_DRIVERS);
  }

  getIncomeDistribution() {
    return this.apiHandler.apiGet(
      API.DASHBOARD_ENDPOINTS.GET_INCOME_DISTRIBUTION
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/dashboard/service/dashboard.service.ts